import { BankAccountDetails, PaymentType } from '@afterpay/types'
import { EnrichedBankAccountDetails, PaymentMethodType, BankAccountErrorReason } from '../model'
import { PreferredCard } from './credit-card'

export const findBankAccount = (savedBankAccounts: BankAccountDetails[]) => (id: number) => {
  return savedBankAccounts.find((account) => account.id === id)
}

export const enrichBankAccount = (account: BankAccountDetails, preferredCard?: PreferredCard): EnrichedBankAccountDetails => ({
  paymentMethodType: PaymentMethodType.ACH_BANK_ACCOUNT,
  error: preferredCard !== undefined && !preferredCard.valid ? 'noValidCard' : null,
  ...account,
})

export const enrichBankAccountOverdue = (account: BankAccountDetails): EnrichedBankAccountDetails => ({
  paymentMethodType: PaymentMethodType.ACH_BANK_ACCOUNT,
  error: 'checkingNotAllowed',
  ...account,
})

export const enrichBankAccountByPaymentType = (account: BankAccountDetails, paymentType: PaymentType): EnrichedBankAccountDetails => ({
  paymentMethodType: PaymentMethodType.ACH_BANK_ACCOUNT,
  error: paymentType === PaymentType.PCL ? 'checkingNotAllowed' : null,
  ...account,
})

export interface PreferredBankAccount {
  account: EnrichedBankAccountDetails | null
  valid: boolean
  switched: boolean
  reason: BankAccountErrorReason | null
}

export const selectPreferredBankAccount = (
  preferredBankAccount: EnrichedBankAccountDetails | null,
  savedBankAccounts: EnrichedBankAccountDetails[]
): PreferredBankAccount => {
  const fallback = savedBankAccounts.filter((account) => account.error === null).pop() ?? null
  if (preferredBankAccount === null) {
    return {
      account: fallback,
      switched: false,
      valid: fallback?.error === null,
      reason: fallback?.error ?? null,
    }
  }
  if (preferredBankAccount.error === null) {
    return {
      account: preferredBankAccount,
      switched: false,
      valid: true,
      reason: null,
    }
  }
  if (fallback !== null) {
    return {
      account: fallback,
      switched: true,
      valid: true,
      reason: preferredBankAccount.error,
    }
  }
  return {
    account: preferredBankAccount,
    switched: false,
    valid: false,
    reason: preferredBankAccount.error,
  }
}
